import script from "./CampaignList.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignList.vue?vue&type=script&setup=true&lang=js"

import "./CampaignList.vue?vue&type=style&index=0&id=7f491de8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f491de8"]])

export default __exports__